var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-anime"},[_c('img',{staticClass:"img-1",attrs:{"src":"/img/magic/mail-sent-empty.svg"}}),_c('img',{staticClass:"img-2",class:{ 'img-2-anim': _vm.wip },attrs:{"src":"/img/magic/airplane.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }